import { BiDashboardSummary } from '@euler/model/bi/dashboard';
import { useServiceFactory } from '@euler/services/factory';
import { useCallback, useEffect, useState } from 'react';
import { biByDefaultThenRecent } from '../../../functions/biByDefaultThenRecent';

export type BiPickerState =
  | { kind: 'loading' }
  | { kind: 'failed' }
  | { kind: 'ready'; items: BiDashboardSummary[] };

/**
 * The dashboards the header picker offers — mine and those shared with me,
 * the default first, then the latest edit — read each time it opens.
 */
export function useBiDashboardPicker(open: boolean) {
  const { biService } = useServiceFactory();
  const [state, setState] = useState<BiPickerState>({ kind: 'loading' });
  const [reload, setReload] = useState(0);
  useEffect(() => {
    if (!open) return;
    let active = true;
    setState({ kind: 'loading' });
    biService
      .dashboards()
      .then(items => {
        if (active)
          setState({
            kind: 'ready',
            items: [...items].sort(biByDefaultThenRecent),
          });
      })
      .catch(error => {
        console.error('BI dashboard picker failed', error);
        if (active) setState({ kind: 'failed' });
      });
    return () => {
      active = false;
    };
  }, [biService, open, reload]);
  const refresh = useCallback(() => setReload(value => value + 1), []);
  const create = useCallback(
    async (name: string) => await biService.createDashboard({ name }),
    [biService],
  );
  return { state, refresh, create };
}
